declare global {
  interface Window {
    plausible: (
      eventName: string,
      props?: { props: { [key: string]: string } }
    ) => void
  }
}
// LIST of Eventname for Plausible
type EventName =
  | 'Contact Us'
  | 'Contact Us Form Submit'
  | 'World Map'
  | 'Start for free'
  | 'Sign In'
  | 'Sign Up'

// List of Custom Properties for Plausible
type CustomProperty =
  | 'World Map Click'
  | 'Contact Us Position'
  | 'Start Position'
  | 'Sign Up Position'

export const logEventToPl = (
  eventName: EventName,
  props?: {
    [key in CustomProperty]?: string
  }
): void => {
  if (!window.plausible) return
  if (props) {
    window.plausible(eventName, { props })
  } else {
    window.plausible(eventName)
  }
}
